"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = require("prop-types");

var _CircularProgress = _interopRequireDefault(require("@material-ui/core/CircularProgress"));

var _seamlessImmutable = require("seamless-immutable");

var _UTLabel = _interopRequireDefault(require("../UTLabel"));

var _WithTheme = _interopRequireDefault(require("../WithTheme"));

var _theme = require("./theme");

var _stylesModule = _interopRequireDefault(require("./styles.module.scss"));

var _constants = require("./constants");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

var Loading = function Loading(_ref) {
  var text = _ref.text,
      className = _ref.className,
      thickness = _ref.thickness,
      size = _ref.size,
      classes = _ref.classes,
      theme = _ref.theme,
      textClassName = _ref.textClassName;
  var defaultSize = (0, _seamlessImmutable.getIn)(theme, ['Loading', 'base', 'size'], 85);
  var defaultThickness = (0, _seamlessImmutable.getIn)(theme, ['Loading', 'base', 'thickness'], 1.5);
  return _react["default"].createElement("div", {
    className: "".concat(_stylesModule["default"].container, " ").concat(className)
  }, _react["default"].createElement(_CircularProgress["default"], {
    className: classes.base,
    size: size || defaultSize,
    thickness: thickness || defaultThickness
  }), _react["default"].createElement(_UTLabel["default"], {
    className: "".concat(_stylesModule["default"].text, " ").concat(classes.text, " ").concat(textClassName),
    medium: true
  }, text || _constants.DEFAULT_LOADING_TEXT));
};

Loading.propTypes = {
  text: _propTypes.string,
  size: _propTypes.number,
  thickness: _propTypes.number,
  classes: (0, _propTypes.shape)(_propTypes.any),
  theme: (0, _propTypes.shape)(_propTypes.any),
  className: _propTypes.string,
  textClassName: _propTypes.string
};

var _default = (0, _WithTheme["default"])(_theme.retrieveStyle)(Loading);

exports["default"] = _default;